import React from 'react';

export const FormSection = () => {
  return <div>FormSection</div>;
};
